import { createSelector } from 'reselect'

import { selectContactsState } from './selectContactsState'

export const selectContactsError = createSelector([selectContactsState], (state) => state.error)
